// src/Components/InputField.jsx
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const InputField = ({
  className = "",
  placeholder,
  Icon,
  iconClassName,
  type = "text",
  name,
  value,
  onChange,
  error,
  onKeyDown,
  formatNumber = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const isPassword = type === "password";

  // Ensure value is treated as string for length check
  const hasValue = value !== undefined && value !== null && value.toString().length > 0;

  const togglePassword = () => setShowPassword(!showPassword);

  // دالة لتنسيق الرقم بالفواصل مع دعم الفواصل العشرية
  const formatNumberWithCommas = (num) => {
    if (num === null || num === undefined || num === "") return "";

    // تقسيم الرقم إلى جزء صحيح وجزء عشري
    const parts = num.toString().split(".");

    // إضافة الفواصل للجزء الصحيح
    // إزالة أي فواصل سابقة والتأكد من أنه رقم
    parts[0] = parts[0].replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // دمج الجزئين مجدداً
    return parts.join(".");
  };

  // دالة للحصول على القيمة بدون فواصل
  const getCleanValue = (num) => {
    if (num === null || num === undefined || num === "") return "";
    return num.toString().replace(/,/g, "");
  };

  // معالجة تغيير القيمة
  const handleChange = (e) => {
    let inputValue = e.target.value;

    if (formatNumber && type === "text") {
      // السماح بالأرقام والنقطة العشرية فقط
      // إزالة الفواصل أولاً للتحقق
      const cleanValue = getCleanValue(inputValue);

      // Regex allowing digits and at most one decimal point
      if (cleanValue === "" || /^\d*\.?\d*$/.test(cleanValue)) {
        const syntheticEvent = {
          ...e,
          target: {
            ...e.target,
            value: cleanValue,
            name: name
          }
        };
        onChange(syntheticEvent);
      }
    } else {
      onChange(e);
    }
  };

  // تحديد القيمة المعروضة
  const displayValue = formatNumber && type === "text" ? formatNumberWithCommas(value) : (value ?? "");

  return (
    <div className="w-full group">
      <div
        className={`relative flex items-center bg-white/50 backdrop-blur-sm rounded-xl px-4 py-3 border-2 transition-all duration-300 min-h-[56px]
          ${error
            ? "border-red-500/50 bg-red-50/10 shadow-[0_0_15px_-5px_rgba(239,68,68,0.2)]"
            : isFocused
              ? "border-main1 bg-white shadow-[0_0_20px_-10px_rgba(28,65,48,0.2)]"
              : "border-transparent bg-grayish/60 hover:bg-white hover:border-gray-200"
          } ${className}`}
      >
        <input
          type={isPassword ? (showPassword ? "text" : "password") : type}
          name={name}
          id={`input-${name}`}
          value={displayValue}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={onKeyDown}
          autoComplete="off"
          className="flex-1 bg-transparent outline-none text-right font-semibold text-main1 placeholder-transparent z-10"
        />

        {/* Floating Label */}
        <label
          htmlFor={`input-${name}`}
          className={`absolute right-4 transition-all duration-300 pointer-events-none select-none z-0
            ${isFocused || hasValue
              ? "text-[10px] font-black text-main1/60 -translate-y-4 uppercase tracking-tighter"
              : "text-sm font-medium text-gray-400 translate-y-0"
            }`}
        >
          {placeholder}
        </label>

        <div className="flex items-center gap-2 mr-3 border-r border-gray-200/50 pr-2">
          {isPassword ? (
            <button
              type="button"
              onClick={togglePassword}
              className="cursor-pointer text-main2/60 hover:text-main2 transition-colors duration-200 focus:outline-none"
              title={showPassword ? "إخفاء" : "إظهار"}
            >
              {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
            </button>
          ) : (
            Icon && (
              <Icon
                className={`text-lg transition-colors duration-300 
                  ${isFocused ? "text-main1" : "text-main2/50 group-hover:text-main2/80"} 
                  ${iconClassName}`}
              />
            )
          )}
        </div>
      </div>

      {error && (
        <div className="flex items-center gap-1 mt-1.5 px-2 animate-fadeIn">
          <div className="w-1 h-1 rounded-full bg-red-500"></div>
          <p className="text-red-500 text-[10px] font-bold uppercase tracking-tight">{error}</p>
        </div>
      )}
    </div>
  );
};

export default InputField;



